<template>
	<form action="" class="card card--lg js-form-validate pop-up--form">
		<div class="card__header">
			<div class="card__title">
				<p>Order overview</p>
			</div>
		</div>
		<div class="card__content" v-if="order.status == 'DELIVERY_ISSUE'">
			<div class="alert alert--notice alert--error">
				<p class="alert__title">This order is marked as not delivered because we haven’t been able to complete the delivery.</p>
			</div>
		</div>
		<div class="card__content">
			<p class="card__subheader">Information</p>
			<div class="card card--xs card--noShadow fill--paper">
				<div class="card__content">
					<div class="grid grid--jcSpaceBetween">
						<p>Order type</p>
						<p class="body" v-if="order.is_gift === 1">Gift</p>
						<p class="body" v-else>{{ order.type | orderTypeToLabel }}</p>
					</div>
					<div class="grid grid--jcSpaceBetween">
						<p>Status</p>
						<p class="body">{{ order.status | statusToLabel }}</p>
					</div>
					<div class="grid grid--jcSpaceBetween">
						<p>Date</p>
						<p class="body">{{ order.date_delivery | dateFormat }}</p>
					</div>
					<div class="grid grid--jcSpaceBetween">
						<p>Time slot</p>
						<p class="body">{{ order.time_slot.humanized_slot }}</p>
					</div>
					<div class="grid grid--jcSpaceBetween" v-if="order.is_gift === 1">
						<p>Recipient</p>
						<p class="body">{{ order.customer_firstname }} {{ order.customer_lastname }}</p>
					</div>
					<div v-if="order.note" class="grid grid--jcSpaceBetween">
						<p>Gift message</p>
						<p class="body">{{ order.note }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="card__content">
			<b-collapse-price :title="'Price Breakdown'" :order="order" :products="order.items"></b-collapse-price>
		</div>
		<div class="card__actions" v-if="order.status == 'CANCELED'">
			<a href="mailto:customer@bluto.co.uk" class="button button--md button--secondary">Contact us</a>
		</div>
	</form>
</template>

<script>
    export default {
    		props: ['order'],
    }
</script>
